export default __webpack_public_path__ + "static/community-block-thumbnail-e46a60fc7f95f612c966a6d313e52441.webp";